import React, {FC} from "react";
import {ReportItemsSearchPanel, ReportPage} from "../../../components";
import {getPageNameByPageId, getUserId} from "../../../utils";
import {ItemReportSearchParamsModel, PageEnum} from "../../../models";
import {searchReportExpiryDateOfItems,} from "../../../serviceBroker/itemsReportApiServiceBroker";

export const ReportExpiryDateOfItemsPage: FC = () => {
    const initialState: ItemReportSearchParamsModel = {Lang: 1, userId: getUserId()};
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportExpiryDateOfItems}
            searchHeader={getPageNameByPageId(PageEnum.ReportExpiryDateOfItems)}
            SearchPanel={ReportItemsSearchPanel}
            withDateRange={true}
            formId={PageEnum.ReportExpiryDateOfItems}
        />
    );
};
